<template>
  <div class="division"><div class="text avenirnextltpro-demi-normal-big-stone-10px">/</div></div>
</template>

<script>
export default {
  name: "Division",
};
</script>

<style>
.division,
.division-1,
.division-2,
.division-3 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 2px;
  position: relative;
  width: fit-content;
}

.text,
.text-1,
.text-2,
.text-1-1 {
  letter-spacing: -0.1px;
  line-height: 17px;
  margin-top: -2px;
  opacity: 0.4;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}
</style>
